import { render, staticRenderFns } from "./LoadingButton.vue?vue&type=template&id=65ea19c2&"
import script from "./LoadingButton.vue?vue&type=script&lang=ts&"
export * from "./LoadingButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports